module.exports = __webpack_public_path__ + "img/rss.d29a110e.png";